export default __webpack_public_path__ + "static/media/ShortBaby-Mg2w.939068c4.ttf";